module.exports = __webpack_public_path__ + "f0a626a47d94ca60eb6dfcb1a8216141.pdf";